module.exports = __webpack_public_path__ + "static/forecast/temperature/freeze-thaw-fe386b4e91cb7f535d71630564377cbc.svg";